<template>
  <div class="box">
    <h5 class="title is-5">{{ $t("devices.fileCounter") }}</h5>
    <canvas ref="myChart"></canvas>
  </div>
</template>
<script>
import { ref, onMounted } from "vue";
import { Chart, registerables } from "chart.js";
import { useI18n } from "vue-i18n";

Chart.register(...registerables);

export default {
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { t } = useI18n();
    const myChart = ref(null);

    onMounted(() => {
      renderChart();
    });

    const renderChart = () => {
      const labels = Object.keys(props.chartData.monthly);
      const counts = Object.values(props.chartData.monthly).map(
        item => item.count
      );
      const maxMovies = Object.values(props.chartData.monthly).map(
        item => item.max_movies
      );

      const ctx = myChart.value.getContext("2d");
      new Chart(ctx, {
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              label: t("devices.receiveCount"),
              data: counts,
              backgroundColor: "rgba(54, 162, 235, 0.6)",
              borderColor: "rgba(54, 162, 235, 1)",
              borderWidth: 1,
              yAxisID: "y"
            },
            {
              label: t("devices.recordCounter"),
              data: maxMovies,
              type: "line",
              fill: false,
              borderColor: "rgba(255, 99, 132, 1)",
              backgroundColor: "rgba(255, 99, 132, 0.2)",
              borderWidth: 1,
              yAxisID: "y1"
            }
          ]
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
              stacked: true,
              type: "linear",
              position: "left"
            },
            y1: {
              beginAtZero: true,
              stacked: false,
              type: "linear",
              position: "right",
              grid: {
                drawOnChartArea: false
              }
            }
          }
        }
      });
    };

    return {
      myChart
    };
  }
};
</script>

<style scoped>
canvas {
  max-width: 100%;
}
</style>
